class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    const drawerInnerEmpty = this.querySelector('.drawer__inner-empty');
    const cartDrawerItems = this.querySelector('cart-drawer-items');
    
    // Determine if cart is empty - check item_count or items array
    let isEmpty = false;
    if (parsedState.item_count !== undefined) {
      isEmpty = parsedState.item_count === 0;
    } else if (parsedState.items) {
      isEmpty = !Array.isArray(parsedState.items) || parsedState.items.length === 0;
    } else {
      // If we can't determine, assume not empty if we have sections to render
      isEmpty = !parsedState.sections || Object.keys(parsedState.sections).length === 0;
    }
    
    // Update is-empty state
    this.classList.toggle('is-empty', isEmpty);
    
    if (drawerInner) {
      drawerInner.classList.toggle('is-empty', isEmpty);
    }
    
    if (cartDrawerItems) {
      cartDrawerItems.classList.toggle('is-empty', isEmpty);
    }
    
    // Hide empty state and show normal drawer content when cart has items
    if (drawerInnerEmpty) {
      drawerInnerEmpty.style.display = isEmpty ? '' : 'none';
    }
    if (drawerInner) {
      drawerInner.style.display = '';
    }
    
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (sectionElement && parsedState.sections) {
        // Try section.section first (for CartDrawerItems), then section.id
        const sectionKey = parsedState.sections[section.section] ? section.section : 
                           (parsedState.sections[section.id] ? section.id : null);
        if (sectionKey && parsedState.sections[sectionKey]) {
          sectionElement.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[sectionKey], section.selector);
        }
      }
    }));

    // Update free shipping bar and upsells after cart update
    if (typeof window.PulseCart !== 'undefined') {
      // Fetch cart to get updated subtotal
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          window.PulseCart.updateFreeShippingBar(cart);
          // Dispatch cart updated event
          document.dispatchEvent(new CustomEvent('pulse:cart:updated', { detail: { cart } }));
        })
        .catch(() => {
          // Silently fail if cart fetch fails
        });
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
